module.exports = __webpack_public_path__ + "img/home-intro-img--mob.1c5e5ea8.png";